<div class="figmaLink">
  @if (figmaResp()) {
    <db-figma-image [url]="figmaResp().screenshot_url"
                    (closeFigma)="onCloseFigma()"
                    [fileName]="figmaResp().node_name"></db-figma-image>
  } @else {
    <div class="figmaInputContainer">
      <img src="assets/images/logos/figma-logo.svg" class="mr9 ml2" alt="avatar"/>
      @if (!isLoading()) {
        <input
          [value]="inputValue()"
          (paste)="onPaste($event)"
          (input)="onChangeValue($event)"
          (keydown)="onKeyDown($event)"
          [class.inputWithValue]="inputValue()"
          [class.figmaLoading]="isLoading()"
          placeholder="Paste your Figma link here..."
          class=""/>
      } @else {
        <div class="figmaLoading">{{inputValue()}}</div>
      }

        <i class="db-icon db-icon-close" (click)="clearValue()"></i>
    </div>
  }
</div>
